import { createStyles } from '@material-ui/core/styles'

// Item colapsado del Sidebar del Storybook de Velora (48 px, radio 6, icono 20 px).
// Se mantiene sobre el color del cliente, así que activo y hover son blancos translúcidos.
export default () =>
  createStyles({
    root: {
      borderRadius: 6,
      display: 'flex',
      width: 48,
      height: 48,
      minHeight: 48,
      margin: '6px 0',
      padding: 0,
      justifyContent: 'center',
      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      '& svg': { width: 20, height: 20 },
      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.12)' },
      '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: 'rgba(255, 255, 255, 0.24)' }
    },
  })
